import { useState } from 'react'
import { StaticRouter } from 'react-router-dom/server'
import { TrackActionProvider } from '@opallabs/analytics'
import { SimpleWorkspace } from '@opallabs/concepts'
import { Theme } from '@opallabs/gem'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { WorkspaceContext, ThemeProvider } from '@opallabs/hooks'
import { AddToPlanModal } from '..'
import type { AddToPlanModalProps } from '../types'
import { QueryableAddTopPlanModalProvider } from './QueryableAddToPlanModalContext'

type QueryableAddToPlanModalProps = Readonly<
  Omit<AddToPlanModalProps, 'isOpen' | 'moments' | 'onCloseModal'> & {
    momentUuid: string
    onCloseModal(invalidationArgs?: {
      planId: string
      workspaceUuid: string
    }): void
    workspace: SimpleWorkspace
    theme: Theme
  }
>

export const QueryableAddToPlanModal: React.FC<
  QueryableAddToPlanModalProps
> = ({ momentUuid, onCloseModal, theme = 'light', workspace }) => {
  const [isVisible, setIsVisible] = useState(true)
  const location = window.top?.location ?? window.location

  return (
    <DefaultQueryClientProvider>
      <StaticRouter location={location.pathname}>
        <ThemeProvider theme={theme}>
          <TrackActionProvider>
            <WorkspaceContext.Provider value={workspace}>
              <QueryableAddTopPlanModalProvider
                momentUuid={momentUuid}
                workspaceSlug={workspace.slug}
              >
                <AddToPlanModal
                  isOpen={isVisible}
                  // supplied by context so it can be defined within QueryClientProvider
                  onAddToPlan={() => null}
                  onCloseModal={(planId) => {
                    setIsVisible(false)
                    onCloseModal(
                      planId
                        ? { planId, workspaceUuid: workspace.uuid }
                        : undefined
                    )
                  }}
                />
              </QueryableAddTopPlanModalProvider>
            </WorkspaceContext.Provider>
          </TrackActionProvider>
        </ThemeProvider>
      </StaticRouter>
    </DefaultQueryClientProvider>
  )
}
